export default __webpack_public_path__ + "static/media/HourlyCost.28cc9cf2.svg";